class EnquiryData {

	/**
	 * Are we using the legacy enquiry form?
	 */
	public isLegacy: boolean;

	/**
	 *
	 * Dynamic form data
	 */
	public data: any;

	/*
	 * Get enquiry based context menu params
	 * We are creating a condition for each enquiry form on the system
	 * if the current collection is smart, then we only need to check if the collection is enabled for enquiry
	 * otherwise, if we are in a legacy world, we just need to check if the enquiry is enabled
	 * refer to CollectionPanel.ts -> getEnquiryMenuGroup where these conditions are first used
	 * @param params - the current context menu params
	 * @returns {{}}
	 */
	public static getMenuData(params:any): any {
		if (EnquiryData.data && !iwCore.isEmptyObject(EnquiryData.data)) {
			let parsedModel, mediaType;
            let canEnquireMediaTypes = true;
            let enquiryMediaTypes = [];
			for (let zoneId in this.data) {
				if (EnquiryData.data.hasOwnProperty(zoneId)) {
					parsedModel = JSON.parse(EnquiryData.data[zoneId]);
                    canEnquireMediaTypes = true;

					// if no restrictions on the enquiry form, then we can show the form
					// otherwise check if we can show based on media types,
					// if no media types in the collection, then we assume the mcc version doesn't support it and show the form anyway

                    // check if we have any media type restrictions on the enquiry form
                    enquiryMediaTypes = (parsedModel['collectionMediaTypes'] || []).map(Number);
                    if(enquiryMediaTypes && enquiryMediaTypes.length > 0){
                        // if the collection has media types, then we need to check if there is an overlap with the enquiry form
                        // otherwise show the form as we don't know what is in the collection (i.e. it could be empty because mcc version < 7.17.1.0)
                        if(params['collectionMediaTypes'] && params['collectionMediaTypes'].length > 0){
                            canEnquireMediaTypes = enquiryMediaTypes.some((type: any) => params['collectionMediaTypes'].includes(type));
                        } else {
                            // if there are no media types in the collection, then check if we have a media type param
                            // (i.e. for the menu in the collection item)
                            if(params['mediaType']) {
                                mediaType = EnquiryData.getMediaTypeNumber(params['mediaType']);
                                canEnquireMediaTypes = enquiryMediaTypes.includes(mediaType);
                            }
                        }
                    }

					// condition based on if it is a smart collection or not
					params['canenquire_'+zoneId] = EnquiryData.getParamValue(params, parsedModel) && canEnquireMediaTypes;
				}
			}
		} else if (EnquiryData.isLegacy) {
			// if it is a legacy form, then no dynamic conditions
			params.canenquire = !!iw.enquireEnabled
		}

		return params;
	}

    /**
     * Get the media type number from the string
     * @param mediaTypeString
     * @private
     */
    private static getMediaTypeNumber(mediaTypeString: string): number | undefined {
        switch (mediaTypeString) {
            case 'video': return 0;
            case 'audio': return 1;
            case 'image': return 2;
            case 'document': return 9;
            default: return undefined;
        }
    }

	/**
	 * Get the enquiry form params
	 * @param params
	 * @param parsedModel
	 * @private
	 */
	private static getParamValue(params:any, parsedModel: any ) {
		// if its an empty collection and collections are enabled, then we don't want to show the enquiry
		if (params.isEmpty && parsedModel['collectionsEnabled']) {
			return false;
		}

		return params.smartid ? !parsedModel['collectionsEnabled'] : !!iw.enquireEnabled;
	}

	/**
	 * Open enquire modal
	 * @param zoneId
	 * @param params
	 * @param el
	 * @param selectionItems
	 * @private
	 */
	public static enquire(zoneId: any, params: any, el: HTMLElement, selectionItems?: any) {
		let data: any = {
			collectionID: params.iwcollectionid,
			collectionURL: decodeURIComponent(params.iwcollection_public_url),
			collectionHits: params.iwcollectionhits
		};

		// if they are using the new form in the cPanel
		if (EnquiryData.data && EnquiryData.data[zoneId]) {
			let parseJson = JSON.parse(EnquiryData.data[zoneId]);
			CISDynamicForm.init(parseJson.elementId,
				parseJson.encryptId,
				parseJson.email,
				parseJson.headerText,
				parseJson.submitText,
				parseJson.successText,
				null,
				'',
				parseJson.dynamicFormItems,
				{
					collectionID: data.collectionID,
					collectionName: params.iwcollectionname,
					collectionDescription: params.iwdescription,
					collectionCreationDate: params.iwcreationdate,
					collectionModifiedDate: params.iwmodifieddate,
					collectionUrl: data.collectionURL,
					collectionHits: data.collectionHits,
					recordName: params.iwrecordname ?? null,
					recordUrl: params.iwrecordid ? ('/record/' + params.iwrecordid) : null,
					collectionItems: selectionItems || []
				});
		} else if (params.iwcollectionid) {
			if (params.iwclipid) {
				data.clipID = params.iwclipid;
				data.isClip = !!parseInt(params.iwisclip, 10);
				data.recordID = params.iwrecordid;
				data.mediaID = params.iwmediaid;
				data.caption = params.iwcaption;
				data.itemURL = decodeURIComponent(params.iwlinkurl || params.iwrecordurl);
			}

			iwModal.create(el, "collectionEnquire", {
				aurl: "/collection/enquireform",
				type: "ajax-body",
				title: iwi18n.gettext(undefined, "Enquire"),
				event: 'collection-enquire',
				data: JSON.stringify(data)
			});
		}
	}

	/**
	 * Add enquiry items to an existing menu group
	 */
	public static getEnquiryMenuGroup() {
		// loop over all enquiry forms user has access too and create a context menu item for it
		let arr = [];
		if (EnquiryData.data && !iwCore.isEmptyObject(EnquiryData.data)) {
			let parsedModel;
			for (let zoneId in EnquiryData.data) {
				if (EnquiryData.data.hasOwnProperty(zoneId)) {
					parsedModel = JSON.parse(EnquiryData.data[zoneId]);
					let headerText = parsedModel.headerText || iwi18n.gettext(undefined, 'Enquire');
					if (headerText.length > 23) {
						headerText = headerText.substring(0, 20) + '...';
					}
					arr.push(
						{
							name: headerText,
							icon: 'iw-icon-email',
							cbFn: EnquiryData.makeEnquiry.bind(this,zoneId),
							// each form has a unique condition
							condition: 'iwcanenquire_' + zoneId,
						}
					)
				}
			}
		} else if (EnquiryData.isLegacy) {
			arr.push(
				{
					name: iwi18n.gettext(undefined, 'Enquire'),
					icon: 'iw-icon-email',
					cbFn: EnquiryData.enquire.bind(this,null),
					condition: 'iwcanenquire'
				}
			);
		}

		return arr;
	}

	/*
	 * Make enquiry callback
	 * @param zoneId
	 * @param params
	 * @param el
	 */
	public static makeEnquiry(zoneId: string, params: any, el: HTMLElement) {
		// if coming from an individual item, then only enquire about that one item
		let selectionItems = [];
		if (params.iwclipid) {
			selectionItems.push({
				clipID: parseInt(params.iwclipid),
			});
		}
		EnquiryData.enquire.call(this,zoneId, params, el, selectionItems);
	}

	/**
	 * Get our enquire data for our new DyanmicForm Enquire (inCpanel)
	 * @private
	 */
	public static getEnquireData() {
		iwCore.ajax({
			type: 'GET',
			url: '/collections/getenquiredata',
			success: (e: any) => {
				let renderLegacyForm = e.renderLegacyForm || false;

				if (e.success) {
					EnquiryData.data = !iwCore.isEmptyObject(e.data) ? e.data : {};
				}

				// should we render the legacy form (if enquiries enabled and there are NO dynamic forms on system for enquiries
				EnquiryData.isLegacy = renderLegacyForm

				// we need to wait for response now before we create menu items,
				// as enquiry items are dependent on the results from this request
				EVENT.custom('EnquiryDataComplete');
			}
		})
	}
}